import React from "react";
import { IconTitleDescriptionActionCard, ButtonBase } from "@reusejs/react";
import ResearchSvgBlog from "../../Icons/ResearchSvgBlog";
import getDate from "services/utils/getDate";
import { useRouter } from "next/router";

interface BlogCardInterface {
  data?: any;
  index?: any;
  latest?: boolean;
  image: any;
}

const BlogCardComponent = (props: BlogCardInterface) => {
  const lengthOfDescription = props.data.description.length;
  const [dateTime, currDate] = getDate(new Date(props.data.publishedAt));
  const router = useRouter();
  const categoryName =
    props.data.category.data.attributes.name.charAt(0).toLocaleUpperCase() +
    props.data.category.data.attributes.name.slice(1);
  const categoryIcon =
    props.data.category?.data.attributes?.categoryIcon?.data?.attributes?.url;

  return (
    <div
      className={`${
        props.index == 0
          ? "grid col-span-2 w-full"
          : "grid md:col-span-1 col-span-2"
      } ${props.latest == true ? "flex w-64 md:w-72 lg:w-96" : ""}`}
    >
      <IconTitleDescriptionActionCard
        actions={
          <div>
            <ButtonBase
              label="Read More ->"
              buttonBaseClasses={{
                font: "md:text-lg text-sm font-semibold my-4 hover:bg-transparent bg-transparent",
                textColor: "text-blue-600",
                border: "pl-0 pr-0",
              }}
              onClick={async () => {
                router.push(`/blogs/${props.data.slug}`);
              }}
            />
          </div>
        }
        description={
          lengthOfDescription > 100
            ? `${props.data.description.substring(0, 100)}...`
            : props.data.description
        }
        icon={
          <div className="flex flex-col justify-between items-center w-full">
            <img
              src={props.image ? props.image : ""}
              alt="post Image"
              className={`rounded-lg cursor-pointer ${
                props.index == 0 && props.latest == false
                  ? "w-full h-36 md:h-72 object-fill"
                  : "w-full h-40 object-fill"
              }`}
              onClick={async () => {
                router.push(`/blogs/${props.data.slug}`);
              }}
            />
            {props.index == 0 && props.latest == false ? (
              <div className="md:hidden flex items-center justify-between w-full mt-4">
                <div className="flex items-center px-3 py-1 bg-sky-100 rounded-md">
                  <div className="svg-dark-blue-class">
                    <img src={categoryIcon} alt="Category Icon" />
                  </div>
                  <div className="text-blue-800 text-xs font-medium ml-2">
                    {categoryName}
                  </div>
                </div>
                <div className="text-sm font-normal text-gray-500">
                  Published At {currDate}
                </div>
              </div>
            ) : (
              <div className="flex items-center justify-between w-full mt-4">
                <div className="flex items-center px-3 py-1 bg-sky-100 rounded-md">
                  <div className="svg-dark-blue-class">
                    <img src={categoryIcon} alt="Category Icon" />
                  </div>
                  <div className="text-blue-800 text-xs font-medium ml-2">
                    {categoryName}
                  </div>
                </div>
                <div className="text-sm font-normal text-gray-500">
                  Published At {dateTime}
                </div>
              </div>
            )}
          </div>
        }
        iconPosition="top-left"
        itemTitleDescriptionCardBaseClasses={{
          wrapper: `flex flex-col mx-auto ${
            props.latest == true ? "w-64 md:w-72 lg:w-96" : "w-full"
          }`,
          actionWrapper: "mt-4",
          descriptionWrapper: "mt-2 md:mt-4 h-14",
          descriptionStyles:
            "lg:text-xl text-xs font-semibold text-gray-500 mt-2",
          iconWrapper:
            "flex items-center col-span-2 rounded-md text-white md:mx-auto",
          titleWrapper: "mt-2 md:mt-5 ",
          titleStyles: "lg:text-2xl text-base font-semibold text-gray-900 h-12",
        }}
        title={
          <div
            className="cursor-pointer"
            onClick={async () => {
              router.push(`/blogs/${props.data.slug}`);
            }}
          >
            {window.innerWidth <= 767 && props.data.title.length > 40
              ? props.data.title.slice(0, 40) + "..."
              : window.innerWidth >= 768 &&
                props.index != 0 &&
                props.data.title.length > 30
              ? props.data.title.slice(0, 30) + "..."
              : props.data.title}
          </div>
        }
      />
    </div>
  );
};

export default BlogCardComponent;
